/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function UnlockIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "unlock", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M7.5 11.5H17.5V19.5H7.5V11.5Z", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M3.5 11.5V7.5C3.5 5.5 4.5 4.5 6.5 4.5C8.5 4.5 9.5 5.5 9.5 7.5V11.5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(UnlockIcon);
export default ForwardRef;
//# sourceMappingURL=unlockIcon.js.map